import {
  IconDefinition,
  faAt,
  faCalendarDays,
  faCircleDot,
  faInputNumeric,
  // faInputText,
  // faLocationDot,
  faPhone,
  faSquareCheck,
  faSubtitles
} from '@fortawesome/pro-regular-svg-icons';

import { DataVariableType } from '@empathy/global/data';

export const DataVariableTypeIcon: Record<DataVariableType, IconDefinition> = {
  [DataVariableType.Text]: faSubtitles,
  [DataVariableType.Radio]: faCircleDot,
  [DataVariableType.Checkbox]: faSquareCheck,
  [DataVariableType.Date]: faCalendarDays,
  // For a hidden question is assumed that it contains a set of options that link to the options of a visible question
  [DataVariableType.Hidden]: faCircleDot,
  // [DataVariableType.Keyboard]: faInputText,
  [DataVariableType.Email]: faAt,
  // [DataVariableType.Locale]: faLocationDot,
  [DataVariableType.NumberType]: faInputNumeric,
  [DataVariableType.Phone]: faPhone
};
